import { render } from "./release-list.vue?vue&type=template&id=2d43cd4e&scoped=true"
import script from "./release-list.ts?vue&type=script&lang=ts"
export * from "./release-list.ts?vue&type=script&lang=ts"

import "./release-list.css?vue&type=style&index=0&id=2d43cd4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d43cd4e"

export default script